<template>
  <v-overlay v-model="loadingModel" class="loader">
    <img src="@/assets/curacel-loader.gif" alt="Loading..." />
  </v-overlay>
</template>

<script lang="ts">
export default defineComponent({
  name: 'Loader',
  setup() {
    const { getLoadingState } = storeToRefs(useAuthStore())
    const loading = computed(() => getLoadingState.value)

    const loadingModel = ref(loading.value)

    watch(loading, (value) => {
      loadingModel.value = value
    })

    return { loadingModel }
  },
})
</script>

<style scoped>
.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 24px;
}

.loader img {
  width: 100%;
  height: 100%;
}
</style>
